import request from '@/utils/request'

export function reimbursement(data) {
  return request({
    url: '/api/reimbursement',
    method: 'post',
    data: data
  })
}

export function reimbursementList(data) {
  return request({
    url: '/api/reimbursement',
    method: 'get',
    params: data
  })
}

export function updateReimbursement(id, data) {
  return request({
    url: '/api/reimbursement/' + id,
    method: 'put',
    data: data
  })
}

export function getMaItemInfoById(data) {
  return request({
    url: '/api/an/worker/getMaItemInfoById',
    method: 'get',
    params: data
  })
}

export function createOrUpdateRemiDetail(data) {
  return request({
    url: '/api/an/worker/createOrUpdateReimDetail',
    method: 'post',
    data: data
  })
}

export function getReimInfo(data) {
  return request({
    url: '/api/an/worker/getReimInfo',
    method: 'get',
    params: data
  })
}

export function createRem(data) {
  return request({
    url: '/api/an/worker/createOrUpdateReim',
    method: 'post',
    data: data
  })
}

/**
 * 报销单列表
 * @param data
 * @returns {*}
 */
export function getRemiList(data) {
  return request({
    url: '/api/an/worker/getReimList',
    method: 'get',
    params: data
  })
}


export function getCategories(data) {
  return request({
    url: '/api/an/worker/getMaCateLv1List',
    method: 'get',
    params: data
  })
}

/**
 * 创建订单和报销单
 * @param data
 * @returns {*}
 */
export function createOrderAndReim(data) {
  return request({
    url: '/api/an/worker/createOrderAndReim',
    method: 'post',
    data: data
  })
}

export function getReimAllStatusList() {
  return request({
    url: '/api/an/worker/getReimAllStatusList',
    method: 'get'
  })
}

export function deleteReim(data) {
  return request({
    url: '/api/an/worker/deleteReim',
    method: 'post',
    params: data
  })
}

export function getReimExcelList(data) {
  return request({
    url: '/api/an/worker/getReimExcelList',
    method: 'get',
    params: data
  })
}

/**
 * 报销数据统计
 * @param data
 * @returns {*}
 */
export function getReimCountChars(data) {
  return request({
    url: '/api/an/worker/getReimCountChars',
    method: 'get',
    params: data
  })
}

/**
 * 获取打款记录列表
 * @param data
 * @returns {*}
 */
export function getPaymentList(data) {
  return request({
    url: '/api/an/worker/getPaymentList',
    method: 'get',
    params: data
  })
}

/**
 * 工人报销负责人审批
 * @param data
 * @returns {*}
 */
export function checkReim(data) {
  return request({
    url: '/api/an/worker/checkReim',
    method: 'post',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/reimbursement.js